/* 🤖 this file was generated by svg-to-ts */
export const iconBlockwallet: {
  name: 'blockwallet';
  data: string;
} = {
  name: 'blockwallet',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><path fill="#000" fill-rule="evenodd" d="M16 32c8.84 0 16-7.16 16-16S24.84 0 16 0 0 7.16 0 16s7.16 16 16 16m8.66-24.67H7.33v17.33h17.33z" clip-rule="evenodd"/></svg>`,
};
